import React, { createContext, useContext, useEffect, useState } from "react";
import Api from "../components/api/api";
import { URL_API } from "../components/constants/api";
import bg from "../assets/bg.jpg";
import logo from "../assets/logo.png";
import content_bg from "../assets/content_bg.png";
import thanh_cong from "../assets/thanh_cong.png";
import da_duoc_su_dung from "../assets/da_duoc_su_dung.png";
import khong_hop_le from "../assets/khong_hop_le.png";

export interface AppTheme {
  bg?: string;
  logo?: string;
  content_bg?: string;
  thanh_cong?: string;
  da_duoc_su_dung?: string;
  khong_hop_le?: string;
}

// Chỉ dùng cho hình nào server chưa upload, hoặc lần đầu mở app mà không gọi được API
const FALLBACK_THEME: Required<AppTheme> = {
  bg,
  logo,
  content_bg,
  thanh_cong,
  da_duoc_su_dung,
  khong_hop_le,
};

const CACHE_KEY = "capitaland-pg-theme";

const readCache = (): AppTheme | null => {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const mergeTheme = (server: AppTheme): Required<AppTheme> => {
  const merged = { ...FALLBACK_THEME };
  (Object.keys(merged) as (keyof AppTheme)[]).forEach((key) => {
    if (server[key]) merged[key] = server[key] as string;
  });
  return merged;
};

const ThemeContext = createContext<AppTheme>({});

export const useAppTheme = () => useContext(ThemeContext);

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  // null = chưa biết theme (chưa có cache, đang gọi API) -> chưa hiển thị hình
  // để tránh nháy hình cũ trong assets trước khi hình từ server về
  const [serverTheme, setServerTheme] = useState<AppTheme | null>(readCache);

  useEffect(() => {
    const loadTheme = async () => {
      try {
        const res: any = await Api.get(URL_API.APP_THEME);
        if (!res.data?.status) throw new Error("Invalid theme response");
        const data: AppTheme = res.data.data || {};

        // Tải trước để màn hình kết quả hiện ngay khi scan
        Object.values(mergeTheme(data)).forEach((src) => {
          new Image().src = src;
        });

        setServerTheme(data);
        try {
          localStorage.setItem(CACHE_KEY, JSON.stringify(data));
        } catch {}
      } catch (e) {
        console.log("loadTheme", e);
        // Không gọi được API: giữ cache, nếu không có thì dùng hình mặc định
        setServerTheme((prev) => prev ?? {});
      }
    };
    loadTheme();
  }, []);

  return (
    <ThemeContext.Provider
      value={serverTheme ? mergeTheme(serverTheme) : {}}
    >
      {children}
    </ThemeContext.Provider>
  );
}
